module.exports = __webpack_public_path__ + "img/zhewan8.fba1f798.jpg";